export default `
  query getProductPriceBySku(
    $filter: ProductAttributeFilterInput,
  ) {
    products(filter: $filter) {
      items {
        price_range {
          ...PriceRangeFields
        }

      }
    }
  }
  fragment PriceRangeFields on PriceRange {
    maximum_price {
      final_price {
        currency
        value
      }
      regular_price {
        currency
        value
      }
    }
    minimum_price {
      final_price {
        currency
        value
      }
      regular_price {
        currency
        value
      }
    }
  }
`;
